import { render, staticRenderFns } from "./ImportRATModal.vue?vue&type=template&id=22fd4269&scoped=true&"
import script from "./ImportRATModal.vue?vue&type=script&lang=js&"
export * from "./ImportRATModal.vue?vue&type=script&lang=js&"
import style0 from "./ImportRATModal.vue?vue&type=style&index=0&id=22fd4269&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22fd4269",
  null
  
)

export default component.exports